<template>
  <shipment-payment-confirmation-view
    class="shipment-proposals-accept-dialog-bid-confirmation-view"
    :shipment="shipment"
    :content-key="'shipment.paragraphs.confirmation_sent'"
    @close="$emit('close')"
  />
</template>

<script>
  import ShipmentPaymentConfirmationView from '@/views/Shippers/components/ShipmentPaymentConfirmationView/index.vue'

  /**
   * @module component - ShipmentProposalsAcceptDialogBidConfirmationView
   * @param {object} shipment - The shipment object
   */
  export default {
    name: 'ShipmentProposalsAcceptDialogBidConfirmationView',
    components: {
      ShipmentPaymentConfirmationView
    },
    props: {
      shipment: {
        type: Object,
        default: null
      }
    }
  }
</script>
